import auth, { TOKEN, TOKEN_HEADER } from 'lib/auth';
import session from 'lib/session';
import * as PropTypes from 'prop-types';
import React, { createElement } from 'react';

import { Redirect, Route, withRouter } from 'react-router-dom';

/**
 * Роутер для авторизованных пользователей
 * @param component компонент для редиректа
 * @param rest остальные пропсы
 * @returns {*}
 * @constructor
 */
const PrivateRoute = ({ component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const token = localStorage.getItem(TOKEN);
      if (token) session.defaults.headers.common.Authorization = `${TOKEN_HEADER} ${token}`;
      return (
        auth.checkToken()
          ? (createElement(component, props))
          : (
            <Redirect to={{
              pathname: '/sign-in',
              state: { from: props.location },
            }}
            />
          )
      );
    }}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(PrivateRoute);
